import React from 'react';
import styles from './PaymentHeader.module.css';
import { useTranslation } from 'react-i18next';

const PaymentHeader = () => {
    const { t } = useTranslation();

    return (
        <section className={styles['paymentHeader-section']} >
        <div className={styles['paymentHeader-container']}>
        <div className={styles['paymentHeader-content']}>
            <h1 className={styles['paymentHeader-title']}>
                {t('paymentHeader.title')}
            </h1>
        </div>
        </div>
        </section>
    );
};

export default PaymentHeader;